import { HomeModernIcon } from "@heroicons/react/24/outline";
import { useLanguage } from "@/context/LanguageContext";
import { HintWindow } from "@/components/ui/HintWindow";
import { Panel } from "@/components/ui/Panel";

export function PortfolioOverviewEmptyState() {
  const { language } = useLanguage();
  const copy = {
    cs: {
      noProperties: "Žádné nemovitosti",
      description:
        "Zatím nemáte přidanou žádnou nemovitost. Přidejte první a začněte sledovat své finance na jednom místě.",
    },
    en: {
      noProperties: "No properties",
      description:
        "You have not added any property yet. Add the first one and start tracking your finances in a clear dashboard.",
    },
  }[language];

  return (
    <HintWindow>
      <Panel variant="shell">
        <div className="flex min-h-[320px] flex-col items-center justify-center rounded-lg bg-white px-6 py-10 text-center text-softiq-primary dark:bg-softiq-dark-surface dark:text-white">
          <div className="rounded-full bg-gray-100 p-5 dark:bg-white/10">
            <HomeModernIcon className="h-10 w-10 text-gray-400 dark:text-white/45" />
          </div>
          <div className="mt-4 space-y-1">
            <h3 className="app-card-title">{copy.noProperties}</h3>
            <p className="mx-auto max-w-xs text-sm text-softiq-primary/60 dark:text-white/60">
              {copy.description}
            </p>
          </div>
        </div>
      </Panel>
    </HintWindow>
  );
}
